
import Vue from 'vue';
import VideoPlayer from '@media/components/video/VideoPlayer.vue';

type widgetType = 'video' | 'stream';

interface Props {
  content: {
    attrs: any;
  };
  type: widgetType;
}

interface Data {
  isVisible: boolean;
  observer: IntersectionObserver | null;
}

interface Computed {
  getKeywords: string[];
  adFree: boolean;
  ads: {
    adFree: boolean;
    keywords: string[];
  };
  lazyload: boolean;
}

export default Vue.extend<Data, unknown, Computed, Props>({
  components: {
    VideoPlayer,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    type: {
      type: String as () => widgetType,
      required: false,
      default: 'video',
    },
  },
  data() {
    return {
      isVisible: false,
      observer: null,
    };
  },
  computed: {
    getKeywords() {
      return this.$store.getters['adForm/getAdsKeywords'];
    },
    adFree() {
      return this.$store.state.piano.access.adFree || false;
    },
    ads() {
      return {
        adFree: this.adFree,
        keywords: this.getKeywords,
      };
    },
    lazyload() {
      return this.content?.attrs?.lead !== true;
    },
  },
  mounted() {
    if (!this.lazyload) return;

    const root = this.$refs.videoPlayer as Element;

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.isVisible = true;
          if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
          }
        }
      },
      {
        root: null,
      }
    );

    if (root) {
      this.observer.observe(root);
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
});
